module.exports = __webpack_public_path__ + "static/media/image-04.b43cb204.jpg";